import { graphql } from "@/lib/gql/__generated__";

export const SnackSettingsUpdate_SnackSettingsPage_Mutation = graphql(`
	mutation SnackSettingsUpdate_SnackSettingsPage(
		$snackSettingsInput: SnackSettingsInput!
		$snackBlocksInput: SnackBlocksInput!
		$guestPageVisibilitySettingsInput: GuestPageVisibilitySettingsInput!
		$shouldUpdateGuestPageVisibility: Boolean!
	) {
		snackSettingsUpdate(input: $snackSettingsInput) {
			userErrors
			snackSettings {
				id
				hotelID
				subDomain
				baseDomain
				ownerType
				validDtEnd
				gtmID
				topPageSnackUUID
			}
		}
		snackBlocksUpdate(input: $snackBlocksInput) {
			userErrors
			snackBlocks {
				id
				hotelID
				uuid
				bgImage
				logoImage
				snsSetting {
					snsColor
					snsIcons {
						snsType
						url
					}
				}
				blocks {
					uuid
					title
					items {
						itemType
						itemUUID
					}
				}
				createdAt
				updatedAt
				isShowOriginalBgImage
				isShowLanguageSwitcher
			}
		}
		# 画面のページの公開状態を変えたときだけ実行する（toGuestPageVisibilitySettingsVariables を参照）
		guestPageVisibilitySettingsUpdate(input: $guestPageVisibilitySettingsInput)
			@include(if: $shouldUpdateGuestPageVisibility) {
			userErrors
			guestPageVisibilitySettings {
				id
				hotelID
				plainVisibility
				magazineVisibility
				snackVisibility
			}
		}
	}
`);
